import { selectAll } from "../utils/utils";
import Swiper from 'swiper/bundle';

export class TeamCards {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.teamCarouselContainer = selectAll("[data-team-carousel]");
  }

  render() {
    this.teamCarousel();
  }

  teamCarousel = () => {
    for (var i = 0; i < this.teamCarouselContainer.length; i++) {
      new Swiper(this.teamCarouselContainer[i], {
        // Responsive breakpoints
        breakpoints: {
          768: {
            slidesPerView: 1.75,
            spaceBetween: 106,
            slidesOffsetBefore: 10,
            slidesOffsetAfter: 10,
          },
          846: {
            slidesPerView: 1.75,
            spaceBetween: 106,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
          },
          924: {
            slidesPerView: 1.75,
            spaceBetween: 106,
            slidesOffsetBefore: 80,
            slidesOffsetAfter: 80,
          },
          1080: {
            slidesPerView: 3,
            spaceBetween: 113,
            slidesOffsetBefore: 160,
            slidesOffsetAfter: 160,
          },
          1185: {
            slidesPerView: 3,
            spaceBetween: 113,
            slidesOffsetBefore: 220,
            slidesOffsetAfter: 220,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 113,
            slidesOffsetBefore: 260,
            slidesOffsetAfter: 260,
          },
          1360: {
            slidesPerView: 3,
            spaceBetween: 113,
            slidesOffsetBefore: 300,
            slidesOffsetAfter: 300,
          },
          1440: {
            slidesPerView: 3,
            spaceBetween: 113,
            slidesOffsetBefore: 340,
            slidesOffsetAfter: 340,
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    };


  };
}